'use strict';

function introRouting($stateProvider) {

    let introBaseState = 'root.share';

    $stateProvider

    /**
     * WITHOUT END-POINT Section - Share
     */
        .state('' + introBaseState + '', {
            abstract: true,
            url: "/share",
            views: {
                '': {
                    template: "<ui-view/>",
                    controller: "ShareSectionController",
                },
                'sidebar@root': {
                    template: '<nav class="navbar-default navbar-static-side" role="navigation"><section-share-just-browsing-side-menu></section-share-just-browsing-side-menu></nav>'
                }
            },
            resolve: {
                loadSectionSpecific: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('./share.section-specific.js');
                            $ocLazyLoad.load({name: module.name});
                            resolve(module);
                        })
                    });
                },
                loadClerkLedgerDeliverableCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-deliverable/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-deliverable")
                    });
                },
            },
            data: {
                baseState: introBaseState,
                requiresLogin: true,
                pageTitle: 'Share',
                showSideMenu: true
            }
        })

        .state('' + introBaseState + '.overview', {
            url: "/overview",
            template: require("./just-browsing/overview.html"),
            data: {
                pageTitle: 'Share'
            }
        });

};

function routing($stateProvider) {

    let baseState = 'root.api-endpoints.existing.share';

    $stateProvider

    /**
     * Section - Share
     */
        .state('' + baseState + '', {
            abstract: true,
            url: "/share",
            views: {
                '': {
                    template: "<ui-view/>",
                    controller: "ShareSectionController",
                },
                'sidebar@root': {
                    template: '<nav class="navbar-default navbar-static-side" role="navigation"><section-share-just-browsing-side-menu></section-share-just-browsing-side-menu></nav>'
                }
            },
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkLedger_columns_by_step = 'exported-files';
                },
                loadSectionSpecific: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('./share.section-specific.js');
                            $ocLazyLoad.load({name: module.name});
                            resolve(module);
                        })
                    });
                },
                loadClueCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clue/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clue")
                    });
                },
                loadInputCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/input/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-input")
                    });
                },
                loadInputResultCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/input-result/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-input-result")
                    });
                },
                loadInterpretationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/interpretation/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-interpretation")
                    });
                },
                loadWhereaboutCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/whereabout/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-whereabout")
                    });
                },
                loadImportSessionCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/import-session/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-import-session")
                    });
                },
                loadImportSessionManyManyFileCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/import-session-many-many-file/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-import-session-many-many-file")
                    });
                },
                loadClerkAmbitionLevelCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ambition-level/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ambition-level")
                    });
                },
                loadClerkAccountCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-account/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-account")
                    });
                },
                loadClerkAccountCategoryCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-account-category/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-account-category")
                    });
                },
                loadClerkTaxEntityTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity-type")
                    });
                },
                loadClerkTransactionRowCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-transaction-row/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-transaction-row")
                    });
                },
                loadClerkVatScenarioCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-vat-scenario/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-vat-scenario")
                    });
                },
                loadClerkTravelClaimCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-travel-claim/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-travel-claim")
                    });
                },
                loadClerkTripCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-trip/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-trip")
                    });
                },
                loadClerkSignificantPeriodCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-significant-period/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-significant-period")
                    });
                },
                loadClerkFiscalYearCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-fiscal-year/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-fiscal-year")
                    });
                },
                loadClerkAccountBalanceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-account-balance/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-account-balance")
                    });
                },
                loadClerkTaxEntityCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity")
                    });
                },
                loadClerkLedgerAccountCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-account/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-account")
                    });
                },
                loadClerkTaxRegionCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-region/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-region")
                    });
                },
                loadClerkLedgerAccountBalanceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-account-balance/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-account-balance")
                    });
                },
                loadClerkLedgerEntryCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-entry/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-entry")
                    });
                },
                loadClerkLedgerEntryRowCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-entry-row/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-entry-row")
                    });
                },
                loadClerkLedgerEntryTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-entry-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-entry-type")
                    });
                },
                loadClerkInvoiceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-invoice/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-invoice")
                    });
                },
                loadClerkTransactionTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-transaction-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-transaction-type")
                    });
                },
                loadClerkLedgerCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger")
                    });
                },
                loadClerkDeliverableCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-deliverable/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-deliverable")
                    });
                },
                loadClerkDeliverableArtifactCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-deliverable-artifact/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-deliverable-artifact")
                    });
                },
                loadClerkLedgerDeliverableCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-deliverable/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-deliverable")
                    });
                },
                loadClerkLedgerDeliverableArtifactCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-deliverable-artifact/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-deliverable-artifact")
                    });
                },
                loadClerkTaxEntityRelationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity-relation/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity-relation")
                    });
                },
                loadClerkTaxEntityRelationTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity-relation-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity-relation-type")
                    });
                },
                loadClerkSupportingDocumentCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-supporting-document/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-supporting-document")
                    });
                },
                loadClerkSupportingDocumentTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-supporting-document-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-supporting-document-type")
                    });
                },
                loadClerkInputResultMetadataCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-input-result-metadata/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-input-result-metadata")
                    });
                },
                loadFileCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/file/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-file")
                    });
                },
                loadFileInstanceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/file-instance/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-file-instance")
                    });
                },
            },
            data: {
                baseState: baseState,
                importSessionProductScope: 'clerk',
                pageTitle: 'Share',
                showSideMenu: true
            }
        })

        .state('' + baseState + '.optionally-by-clerk-ledger-deliverable', {
            abstract: true,
            url: "/:activeClerkLedgerDeliverableId",
            params: {activeClerkLedgerDeliverableId: {value: 'browsing', dynamic: true}},
            resolve: {
                setRouteBasedContentFiltersLevel1A: /*@ngInject*/ function (setRouteBasedContentFiltersLevel0, routeBasedContentFilters, $stateParams) {
                    routeBasedContentFilters.ImportSession_product_scope = 'clerk';
                    routeBasedContentFilters.ClerkDeliverable_section_scope = 'share';
                    routeBasedContentFilters.ClerkLedgerDeliverable_ClerkDeliverable_section_scope = 'share';
                    // Make these reset to empty by default in this section unless otherwise specified
                    routeBasedContentFilters.ClerkFiscalYear_ClerkTaxEntity_ClerkTaxEntityType_ref = null;
                    routeBasedContentFilters.ClerkLedger_ClerkTaxEntity_ClerkTaxEntityType_ref = null;
                    routeBasedContentFilters.ClerkTaxEntity_ClerkTaxEntityType_ref = null;
                    routeBasedContentFilters.ClerkTaxEntity_knowledge_of_internals_expected = null;
                },
                currentClerkLedgerDeliverable: /*@ngInject*/ function (dataEnvironmentParam, $stateParams, clerkLedgerDeliverable) {
                    console.log('optionally-by-clerk-ledger-deliverable - currentClerkLedgerDeliverable', $stateParams);
                    var clerkLedgerDeliverableId = $stateParams.activeClerkLedgerDeliverableId === 'browsing' ? null : $stateParams.activeClerkLedgerDeliverableId;
                    if (clerkLedgerDeliverableId) {
                        clerkLedgerDeliverable.$activate();
                        return clerkLedgerDeliverable.load($stateParams.activeClerkLedgerDeliverableId);
                    } else {
                        return clerkLedgerDeliverable.load(null);
                    }
                },
            },
            views: {
                '': {
                    template: "<ui-view/>",
                    controller: /*@ngInject*/ function (routeBasedContentFilters, $scope, clerkLedgerDeliverable) {

                        this.uiOnParamsChanged = function (changedParams, $transition$) {
                            console.log('optionally-by-clerk-ledger-deliverable - routes.uiOnParamsChanged', changedParams, $transition$);
                            if (changedParams.activeClerkLedgerDeliverableId) {
                                var clerkLedgerDeliverableId = changedParams.activeClerkLedgerDeliverableId === 'browsing' ? null : changedParams.activeClerkLedgerDeliverableId;
                                if (clerkLedgerDeliverableId) {
                                    clerkLedgerDeliverable.$activate();
                                    clerkLedgerDeliverable.load(changedParams.activeClerkLedgerDeliverableId);
                                } else {
                                    clerkLedgerDeliverable.load(null);
                                }
                            }
                        };
                    },
                },
            },
        });

    // just-browsing
    let justBrowsingSubsection = require('./just-browsing/routes.js');
    justBrowsingSubsection.loadRoutesLazily($stateProvider, '' + baseState + '.optionally-by-clerk-ledger-deliverable.just-browsing');

}

export default angular
    .module('share.routing', [])
    .config(function ($stateProvider) {

        // Lazy load the states instead of loading them all at app bootstrap

        /*
         let lazyIntroStateProvider = {
         states: [],
         state: function (name, stateConfig) {
         let state = angular.merge({name: name}, stateConfig);
         this.states.push(state);
         return this;
         }
         };
         introRouting(lazyIntroStateProvider);
         $stateProvider.state('root.share.**', {
         url: "/share",
         lazyLoad: function ($transition$, ParentService) {
         return lazyIntroStateProvider;
         },
         });
         */
        // Eager-loading intro-states since there are issues with those routes and since they are so few, it is ok to load them eagerly for now
        introRouting($stateProvider);

        let lazyStateProvider = {
            states: [],
            state: function (name, stateConfig) {
                let state = angular.merge({name: name}, stateConfig);
                this.states.push(state);
                return this;
            }
        };
        routing(lazyStateProvider);
        $stateProvider.state('root.api-endpoints.existing.share.**', {
            url: "/share",
            lazyLoad: function ($transition$, ParentService) {
                return lazyStateProvider;
            },
        });

    });



// WEBPACK FOOTER //
// .-dna/app/sections/8-share/share.routing.js